import React from 'react';
import { Stack, Box } from '@mui/material';
import lapiz from '../../../components/assets/lapiz.png';
import { styled } from '@mui/material/styles';

const Img = styled('img')(({theme}) => ({
  maxWidth: '100%',
  maxHeight: 200,
  minWidth: 300,
  width: '100%',
  objectFit: 'contain',
  position: 'absolute',
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

const ImgShadow = styled('img')(({theme}) => ({
  maxWidth: '100%',
  maxHeight: 200,
  minWidth: 300,
  width: '100%',
  objectFit: 'contain',
  opacity: 0.15,
  filter: 'brightness(0.1)',
  zIndex: -1,
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

const Conclusion = (props) => {
  const { B } = props;

  // const handleScroll = () => {
  //   const position = window.pageYOffset;
  //   setScrollPosition(position);
  // };

  window.onmousemove = (e) => {
      let x = e.clientX;
      let y = e.clientY;
      let shadow = document.getElementById('person')
      shadow && shadow.setAttribute('style', `right: ${x/1200 * 8}px; bottom: ${y/600 * 8}px`);
  }

  // React.useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [ref]);



  return (
    <Stack alignItems="center" sx={{ py: 5, px: '5%'}}>
      <Stack sx={{ maxWidth: '1200px', width: '100%' }} spacing={2} direction={{ xs: 'column', md: 'row' }} alignItems="center">
        <Stack sx={{ position: 'relative' }}>
          <Img id="person" src={lapiz} alt="Líderes en Movimiento" />
          <ImgShadow src={lapiz} alt="Líderes en Movimiento" />
        </Stack>
        <Stack spacing={2}>
          <Box textAlign="justify">
            <B>LeM</B> es un espacio en el que las y los estudiantes pueden <B>converger y compartir sus conocimientos</B>,
            formas de pensar y ganas de <B>generar un cambio social</B>, además de contrastar ideas ajenas a su realidad,
            a partir de la convivencia con estudiantes de otros estados y estratos socioeconómicos, con culturas
            distintas, pero perfiles similares.
          </Box>
          <Box textAlign="justify">
            Esto mientras participan en un <B>programa educativo intensivo</B>, compuesto por cursos, talleres, conferencias,
            sesiones de debate, mentorías y experiencias de viajes que buscan impulsar el desarrollo de habilidades
            cognitivas y socioemocionales a fin de prepararlos para <B>convertirse en líderes</B> en un mundo complejo.
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Conclusion;
